import { Block } from 'baseui/block';
// types
import { ISP_Puffer } from './types'
// components
import { TrendPanel } from './TrendPanel';
import { ValuePanelIcon } from '../../Devices/SensorAnalog'
import { SmallPanel as AlarmPanel } from '../../Devices/SensorDigitalAlarm/SmallPanel'
// api
import { useGetObjectsChildrenQuery } from '../../../services/objects'
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { ValueDisplayWithLabel } from '../../components/ValueDisplay';
import { FaPray } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
import { GraphicPuffer } from './IconPuffer';
import { themedUseStyletron } from '../../../theme/customTheme';
import { IAutomationObject } from '../../types';
import { useMemo } from 'react';


export function SmallPanelTrend(props: ISP_Puffer) {
    const [css, theme] = themedUseStyletron();

    const { children: childElement } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const temperature = useMemo(() => childElement?.find((v: IAutomationObject) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor"),[childElement]);
    const temperature1 = useMemo(() => childElement?.find((v: IAutomationObject) => v.schema === "AutomationApps.Devices.Sensors.Temperature1Sensor"),[childElement]);


    return (
        <>
            {!temperature1 && temperature &&
                <ValueDisplayWithLabel    label={<FormattedMessage id="SP_Puffer.bufferTemperature" defaultMessage={'Buffer'}></FormattedMessage>} {...temperature}></ValueDisplayWithLabel>
            }
            {temperature1 &&
                <ValueDisplayWithLabel  label={<FormattedMessage id="SP_Puffer.bufferTemperature" defaultMessage={'Buffer'}></FormattedMessage>} {...temperature1}></ValueDisplayWithLabel>
            }

            {!temperature1 && temperature &&
                <TrendPanel    temperature={temperature} />
            }
            {temperature1 &&
                <TrendPanel  temperature={temperature1} />
            }
        </>
    );
}